<template>
  <full-screen-loader v-if="loading"/>
  <smd-one-col-layout v-else
                      class="d-root-medicine-order-details"
                      content-styles="full-width dark-light-bg">

    <smd-header class="top-bar-box-shadow" slot="header" nav>
      <span class="ns-icon-ico027"
            slot="left-actions"
            v-if="$isMobile"
            @click="goBack"/>
      <span class="ns-icon-ico027"
            slot="right-actions"
            v-else
            @click="goBack"/>
      <text-string :label-id="computedTitle"/>
      <span class="ns-icon-ico001"
            v-if="$isMobile"
            slot="right-actions">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
    </smd-header>

    <div :class="{'d-root-medicine-order-details__grid': isTwoCol}">
      <div v-if="displaySteps"
           class="d-root-medicine-order-details__step">
        <smd-step-progress :horizontal="isTwoCol"
                           :options="steps"
                           :current-step="currentStep"/>
      </div>

      <component v-if="serviceOrder"
                 :service-order="serviceOrder"
                 :watsons-branches="watsonBranches"
                 :is="displayedComponent"
                 :token="this.token"
                 @refetch="fetchOrder">
      </component>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import RootMedicineOrderDetailsMixin from "@/views/common/medicine-order-details/root-medicine-order-details-mixin";

  export default {
    name: 'd-root-medicine-order-details',
    mixins: [RootMedicineOrderDetailsMixin]
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .d-root-medicine-order-details__grid {
    @include make-grid-cols(minmax(0, 260px) 1fr);
    @include responsive('min-width: 1800px') {
      grid-template-columns: 0 1fr;
    }
  }

  .d-root-medicine-order-details__step {
    @include responsive('min-width: 1024px') {
      margin-left: 40px;
    }

    padding: 50px 20px;
  }
</style>